import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {idCheck, pauseIconYellow, userRed} from '../../../assets/images/images';
import {customStyles, DropdownIndicator, Radios} from '../../../components';
import {useFraudCheck, usePersistFraudData} from '../../../hooks/useFraudCheck';
import {Card, Wrapper} from '../FraudCheckScreens';
import {duplicateIdRules} from '../../../helpers/constants/widgets';

export const DetectWithDuplicateID = () => {
  const [duplicateIdRule, setDuplicateIdRule] = useState('');

  const {setSelectedStatus, selectedStatus, setConfig, config, STATUSES} =
    useFraudCheck({
      action_returned: 'blocked',
      resume_verification: false,
    });

  useEffect(() => {
    setDuplicateIdRule(config?.resume_verification ? 'Enable' : '');
  }, [config?.resume_verification]);

  const statusData = usePersistFraudData({
    config,
    selectedStatus,
    actionKey: 'action_returned',
    COLLECTION: STATUSES,
  });

  return (
    <Wrapper>
      <Card
        src={idCheck}
        extension={
          <div className="flex flex-col gap-1">
            <p className="text-grey font-medium">Duplicate ID Check</p>
            <p className="text-body text-sm gap-1">
              Resume verifications using unique email address or reference ID
              and Detect multiple onboarded IDs
            </p>
          </div>
        }
      />

      <Card
        extension={
          <div className="flex flex-col">
            <p className="text-grey font-medium">Resume Verifications</p>
            <p className="text-body text-sm gap-1">
              Allow users to pick up from where they dropped off without
              starting verification from scratch.
            </p>
          </div>
        }
        src={pauseIconYellow}
      >
        <Radios
          data={duplicateIdRules}
          flexDirection="flex-row gap-4"
          radioClassName="bg-white80 w-full p-3 py-3 rounded"
          outerRadioClassName="w-full"
          padding="px-0"
          className="ml-6  w-full"
          onCheck={e => {
            const {value} = e.target;
            setDuplicateIdRule(value);
            setConfig({...config, resume_verification: Boolean(value)});
          }}
          radioValue={duplicateIdRule}
        />

        {/*<div className="flex items-center gap-2 p-4 rounded bg-white80 w-full">*/}
        {/*  <SettingsToggle*/}
        {/*    isChecked={config?.two_names_rule}*/}
        {/*    onCheck={value => {*/}
        {/*      setConfig({...config, two_names_rule: value});*/}
        {/*    }}*/}
        {/*  />*/}
        {/*  <p className="text-grey text-sm">*/}
        {/*    {config?.two_names_rule ? 'Disable' : 'Enable'} match rule{' '}*/}
        {/*  </p>*/}
        {/*</div>*/}
      </Card>

      <Card
        extension={
          <p className="text-grey font-medium">If multiple IDs detected</p>
        }
        src={userRed}
      >
        <div className="text-start w-full">
          <label htmlFor="status" className="mb-2 relative">
            Set status to
          </label>
          {statusData !== undefined && (
            <Select
              defaultValue={statusData}
              value={statusData || STATUSES[0]}
              onChange={status => {
                setSelectedStatus(status);
                setConfig({...config, action_returned: status.value});
              }}
              options={STATUSES}
              className="basic-multi-select"
              classNamePrefix="react-select"
              components={{DropdownIndicator}}
              styles={customStyles}
              menuPlacement="auto"
              isSearchable={false}
            />
          )}
        </div>
      </Card>
    </Wrapper>
  );
};
